export const baseGrtURL = {
    development: 'https://dev-apaas.grtcloud.net',
    // test: 'https://test-apaas.grtcloud.net',
    test: 'https://test-apaas.grtcloud.net',
    prod: 'https://apaas.grtcloud.net',
    local: 'http://127.0.0.1:4523/m1/1606492-0-4e213591'
}[process.env.REACT_APP_MODE];

export const baseAiURL = {
    development: 'https://test-ai-api.grtcloud.net',
    test: 'https://test-ai-api.grtcloud.net',
    prod: 'https://ai-api.grtcloud.net',
    local: 'https://test-ai-api.grtcloud.net'
}[process.env.REACT_APP_MODE];

export const baseUrl = {
    development: 'https://dev-apaas.grtcloud.net/api',
    // test: 'https://test-apaas.grtcloud.net/api',
    test: 'https://test-apaas.grtcloud.net/api',
    prod: 'https://apaas.grtcloud.net/api'
    // eslint-disable-next-line no-undef
}[process.env.REACT_APP_MODE];
export const baseDeerFlowURL = {
    // development: 'https://test-apaas.grtcloud.net/grt-deerflow-task',
    development: 'https://test-apaas.grtcloud.net/grt-deerflow-task',
    // test: 'https://test-apaas.grtcloud.net/grt-deerflow-task',
    test: 'https://test-apaas.grtcloud.net/grt-deerflow-task',
    prod: 'https://apaas.grtcloud.net/grt-deerflow-task',
    // local: 'https://test-apaas.grtcloud.net/grt-deerflow-task'
    local: 'https://test-apaas.grtcloud.net/grt-deerflow-task'
}[process.env.REACT_APP_MODE];
export const baseTTS = {
    // development: 'https://test-apaas.grtcloud.net/api/grt-ai-tts/proxyAIGCFetch',
    development: 'https://test-apaas.grtcloud.net/api/grt-ai-tts/proxyAIGCFetch',
    // test: 'https://test-apaas.grtcloud.net/api/grt-ai-tts/proxyAIGCFetch',
    test: 'https://test-apaas.grtcloud.net/api/grt-ai-tts/proxyAIGCFetch',
    prod: 'https://apaas.grtcloud.net/api/grt-ai-tts/proxyAIGCFetch',
    // local: 'https://test-apaas.grtcloud.net/api/grt-ai-tts/proxyAIGCFetch'
    local: 'https://test-apaas.grtcloud.net/api/grt-ai-tts/proxyAIGCFetch'
}[process.env.REACT_APP_MODE];
export const bucketName = {
    development: {
        video: 'ttcdw6-vod-video-test',
        audio: 'ttcdw6-vod-video-test',
        other: 'ttcdw6-public-test',
        oss: 'ttcdw6-file-test',
        oss_audio: 'ttcdw6-audio-test'
    },
    test: {
        video: 'ttcdw6-vod-video-test',
        audio: 'ttcdw6-vod-video-test',
        other: 'ttcdw6-public-test',
        oss: 'ttcdw6-file-test',
        oss_audio: 'ttcdw6-audio-test'
    },
    prod: {
        video: 'ttcdw6-vod-video',
        audio: 'ttcdw6-vod-video',
        other: 'ttcdw6-public',
        oss: 'ttcdw6-file',
        oss_audio: 'ttcdw6-audio'
    }
}[process.env.REACT_APP_MODE];
export const obsSignUrl = {
    development: 'https://apaas.grtcloud.net/api/obs/signed/url',
    test: 'https://apaas.grtcloud.net/api/obs/signed/url',
    production: 'https://apaas.grtcloud.net/api/obs/signed/url'
}[process.env.REACT_APP_MODE];

export const baseMultimodalDocumentURL = {
    development: 'https://dev-apaas.grtcloud.net/api/grt-resource-manage-service',
    // test: 'https://test-apaas.grtcloud.net/api/grt-user-center-service',
    test: 'https://test-apaas.grtcloud.net/api/grt-user-center-service',
    prod: 'https://apaas.grtcloud.net/api/grt-user-center-service',
    // local: 'https://test-apaas.grtcloud.net/api/grt-resource-manage-service'
    local: 'https://test-apaas.grtcloud.net/api/grt-resource-manage-service'
}[process.env.REACT_APP_MODE];
export const baseMultimodalDocumentURLToken = {
    // development: 'https://test-apaas.grtcloud.net/api/grt-user-center-service',
    development: 'https://test-apaas.grtcloud.net/api/grt-user-center-service',
    // test: 'https://test-apaas.grtcloud.net/api/grt-user-center-service',
    test: 'https://test-apaas.grtcloud.net/api/grt-user-center-service',
    prod: 'https://apaas.grtcloud.net/api/grt-user-center-service',
    // local: 'https://test-apaas.grtcloud.net/api/grt-user-center-service'
    local: 'https://test-apaas.grtcloud.net/api/grt-user-center-service'
}[process.env.REACT_APP_MODE];
